/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../revvComponents";

import Notes from "../Notes";
import Catalog from "../Catalog";
import Collaborators from "../Collaborators";

import { changeToolsView } from "../../actions/DocumentActions";
/*
Rewrite
DocumentToolBar is fine for now, but has to be made a global Toolbar in the future,
as the toolbar is not just for the Documnets. Will be needed on Pricebooks, templates, etc
TODO items for above:
* Move toolsView state to redux : DONE
* name this component accordingly
* make it independent of documentDetails
*/

class DocumentToolBar extends Component {
  _changeView = (event, view) => {
    const { toolsView } = this.props;
    if (toolsView === view) {
      this.props.changeToolsView("");
    } else {
      this.props.changeToolsView(view);
    }
  };

  _getToolBarView = () => {
    const { toolsView } = this.props;
    switch (toolsView) {
      case "notes":
        return (
          <div className="context-tool-pane">
            <Notes {...this.props} />
          </div>
        );
      case "catalog":
        return (
          <div className="context-tool-pane context-tool-pane-width-more">
            <Catalog />
          </div>
        );
      case "collab":
        return (
          <div className="context-tool-pane">
            <Collaborators {...this.props} />
          </div>
        );
      default:
        return null;
    }
  };

  render() {
    return (
      <div className="context-tool-pane-wrapper">
        {this._getToolBarView()}
        <div className="context-tool-list">
          {
            // Rewrite
            // read below list of tools from a json and map over it
          }
          {this.props.currentView === "deal-table" &&
          !this.props.document.isLocked ? (
            <div
              className={
                this.props.toolsView === "catalog"
                  ? "context-tool-apps active"
                  : "context-tool-apps"
              }
              onClick={event => this._changeView(event, "catalog")}
              // onKeyDown={event => this._changeView(event, "catalog")}
              tabIndex="0"
              role="button">
              <Tooltip placement="left" overlay="Product Catalog">
                <span className="context-tool-apps-icon product-catalog">
                  <FontAwesomeIcon icon={["fas", "clipboard-list-check"]} />
                </span>
              </Tooltip>
            </div>
          ) : null}

          <div
            className={
              this.props.toolsView === "notes"
                ? "context-tool-apps active"
                : "context-tool-apps"
            }
            onClick={event => this._changeView(event, "notes")}
            // onKeyDown={event => this._changeView(event, "notes")}
            tabIndex="0"
            role="button">
            <Tooltip placement="left" overlay="Notes">
              <span className="context-tool-apps-icon sticky-note">
                <FontAwesomeIcon icon={["fas", "sticky-note"]} />
              </span>
            </Tooltip>
          </div>

          {/* <div className="context-tool-apps">
            <Tooltip placement="left" overlay="Activities">
              <span className="context-tool-apps-icon audit-trial">
                <FontAwesomeIcon icon={["fas", "heart-rate"]} />
              </span>
            </Tooltip>
          </div> */}

          <div
            className={
              this.props.toolsView === "collab"
                ? "context-tool-apps active"
                : "context-tool-apps"
            }
            onClick={event => this._changeView(event, "collab")}
            tabIndex="0"
            role="button">
            <Tooltip placement="left" overlay="Collaborators">
              <span className="context-tool-apps-icon rightpane-users">
                <FontAwesomeIcon icon={["fas", "users"]} />
              </span>
            </Tooltip>
          </div>
        </div>
      </div>
    );
  }
}

// export default DocumentToolBar;

const mapStateToProps = state => {
  const { toolsView, document } = state.DocumentStore;
  return { toolsView, document };
};

const mapDispatchToProps = { changeToolsView };

export default connect(mapStateToProps, mapDispatchToProps)(DocumentToolBar);
